module.exports = __webpack_public_path__ + "img/Piece-18-Inspect-Large.7a6419e0.png";